import { __require as u } from "./main49.js";
var e, a;
function _() {
  if (a) return e;
  a = 1;
  var t = u();
  function i(r) {
    return t(this, r).get(r);
  }
  return e = i, e;
}
export {
  _ as __require
};
